class InteractiveNote {
  constructor(data) {
    this.text = data.text
    this.singleLine = data.singleLine || false
    this.image = data.image
    this.icon = data.icon
    this.withMargin = typeof data.withMargin === 'undefined' ? true : data.withMargin
  }

  get type() {
    return 'note'
  }

  getImageHtmlOutput() {
    if (!this.image || !this.image.show) {
      return ''
    }
    return '<img src="' + this.image.src + '" style="' +
      'height: ' + this.image.height + 'px; ' +
      'width: auto;' +
      'float: ' + this.image.position + ';' +
      'margin-' + this.image.position + ': 0.2em;"' +
      ' class="note-image">'
  }

  getIconHtmlOutput() {
    if (!this.icon || !this.icon.show) {
      return ''
    }
    return '<img src="' + this.icon.src + '" style="' +
      'height: ' + this.icon.height + 'px; ' +
      'vertical-align: top; ' +
      'margin-' + (this.icon.position === 'end' ? 'left' : 'right') + ': 0.2em;"' +
      ' class="note-icon">'
  }

  getHtmlOutput() {
    var style = this.withMargin ? ' style="margin: 0.5em;"' : ''
    var html = '<div ' + style + '>'
    html += this.getImageHtmlOutput()
    var text = '<span>' + this.text + '</span>'
    var icon = this.getIconHtmlOutput()
    if (this.icon && this.icon.position === 'end') {
      html += text + icon
    } else {
      html += icon + text
    }
    html += '</div>'
    return html;
  }
}

export { InteractiveNote }
